module.exports = __webpack_public_path__ + "img/TV_clean_box03.f4f99e00.jpg";